import { Pagination } from '@innovyze/shared-utils';

export interface ImageListConfiguration {
	limit?: number;
	sortBy?: string;
}

export interface ImageItem {
	_id: string;
	imageKey: string;
	name: string;
}

export interface ImageListResponse {
	pagination: Pagination;
	images: ImageItem[];
}

export interface ImageStoreState {
	images: ImageItem[];
	initialized: boolean;
}
